import { useState } from 'react';
import { Popover, Avatar, Tabs, List, Button, Typography, App } from 'antd';
import {
  UserOutlined, EditOutlined, ProfileOutlined, WalletOutlined, LogoutOutlined,
  SettingOutlined, QuestionCircleOutlined, LockOutlined, CommentOutlined, UnorderedListOutlined
} from '@ant-design/icons';
import avatar1 from 'assets/images/users/avatar-1.png';
import { useAuth } from 'contexts/AuthContext';

const { Text } = Typography;

const profileItems = [
  { icon: <EditOutlined />, label: 'Edit Profile' },
  { icon: <UserOutlined />, label: 'View Profile' },
  { icon: <ProfileOutlined />, label: 'Social Profile' },
  { icon: <WalletOutlined />, label: 'Billing' },
  { icon: <LogoutOutlined />, label: 'Logout' }
];

const settingItems = [
  { icon: <QuestionCircleOutlined />, label: 'Support', href: 'https://codedthemes.support-hub.io/' },
  { icon: <UserOutlined />, label: 'Account Settings' },
  { icon: <LockOutlined />, label: 'Privacy Center' },
  { icon: <CommentOutlined />, label: 'Feedback', href: 'https://codedthemes.support-hub.io/' },
  { icon: <UnorderedListOutlined />, label: 'History' }
];

function ProfileTab() {
  return (
    <List
      size="small"
      dataSource={profileItems}
      renderItem={(item) => (
        <List.Item style={{ padding: '8px 0', cursor: 'pointer' }}>
          <List.Item.Meta avatar={item.icon} title={item.label} />
        </List.Item>
      )}
    />
  );
}

function SettingTab() {
  return (
    <List
      size="small"
      dataSource={settingItems}
      renderItem={(item) => (
        <List.Item style={{ padding: '8px 0', cursor: 'pointer' }}>
          <List.Item.Meta
            avatar={item.icon}
            title={item.href ? <a href={item.href} target="_blank" rel="noreferrer">{item.label}</a> : item.label}
          />
        </List.Item>
      )}
    />
  );
}

export default function Profile() {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth()
  const { modal } = App.useApp();

  const handleLogout = () => {
    modal.confirm({
      title: "Are you sure you want to logout?",
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        logout();
      },
    });
  };
  const content = (
    <div style={{ width: 280 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar src={avatar1} size={32} />
          <div>
            <Text strong style={{ display: 'block', fontSize: 13 }}>John Doe</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>UI/UX Designer</Text>
          </div>
        </div>
        <Button type="text" onClick={handleLogout} icon={<LogoutOutlined />} />
      </div>
      <Tabs
        size="small"
        items={[
          { key: 'profile', label: <><UserOutlined /> Profile</>, children: <ProfileTab /> },
          { key: 'setting', label: <><SettingOutlined /> Setting</>, children: <SettingTab /> }
        ]}
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <Avatar src={avatar1} size={40} style={{ cursor: 'pointer' }} />
    </Popover>
  );
}
